import { Component, OnInit } from '@angular/core';
import { RepairMaintenanceComponent } from '../repair-maintenance/repair-maintenance.component';
import { SessionStore } from '@ildes/stores/session.store';
import { SelectMaterialFromStoreDialogComponent } from '../select-material-from-store-dialog/select-material-from-store-dialog.component';
import { humanizeDate } from '@ildes/utils/formatters';
@Component({
  selector: 'app-detail-maintenance',
  templateUrl: './detail-maintenance.component.html',
  styleUrls: ['./detail-maintenance.component.css']
})
export class DetailMaintenanceComponent extends RepairMaintenanceComponent {
    updateMode = false;
    loadingChanges = false;

  ngOnInit(): void {
    this.updateMode = this.route.snapshot.data['update'];
    const sub =  SessionStore.getInstance().get$().subscribe((data) => {
        if (!data?.user) {

            return;
        }
        this.user = data?.user;
    });
    this.addSubscription(sub);

    this.route.queryParams.subscribe(params => {
        this.pendingRequest = true;
        this.apiManager.getDetailMaintenance(params.id).subscribe((data) => {
            this.pendingRequest = false;
            this.maintenance = data;
            this.fetchDailyQuestionary(this.maintenance.technician?.id);
            this.fetchMaintenanceTask().subscribe();
        })
    });
  }

  get descriptionStep3() {
    if (!this.initialPhotosCompleted) {
      return 'Aún no se han añadido fotos.';
    }
    if (this.maintenance?.photos?.initial?.length) {
      return `Se han añadido ${this.maintenance?.photos?.initial?.length} fotos.`;
    }

    return 'No se han añadido fotos';
  }

  get descriptionStep4() {
    if (this.maintenance?.usedMaterials?.length !== undefined) {
      return `
              Fecha de reparación: ${humanizeDate(this.maintenance.repairmentDate)}.<br>
              Usado: ${this.humaniceMaterials(this.maintenance?.usedMaterials)}.<br>
              Retirado: ${this.humaniceMaterials(this.maintenance?.extractedMaterials)}.<br>
              Actividades: ${this.maintenance.activities?.length || '-'}.<br>
              Nueva luminaria: ${this.humanizeLuminaryData()}.<br>
              Uso temporal: ${this.maintenance.luminaryOfTemporalUse ?  'Sí' : 'No'}.<br>
              Observaciones: ${this.maintenance?.description || '-'}.`
    }
    return 'Este paso aun no se ha completado.';
  }

  get descriptionStep5() {
    if (!this.finalPhotosCompleted) {
      return 'Aún no se han añadido fotos.';
    }
    if (this.maintenance?.photos?.final?.length) {
      return `Se han añadido ${this.maintenance?.photos?.final?.length} fotos.`;
    }

    return 'No se han añadido fotos';
  }
 
  openSigned() {
    this.apiManager.getEvidence({ taskId: this.maintenanceTask.id }).subscribe(({ data }) => {
      this.open(data.signedDocumentName);
    });
  }

  updateReparimentData() {
    const dialog = this.dialog.open(SelectMaterialFromStoreDialogComponent, {
        width: '600px',
        height: '600px',
        panelClass: 'responsive-dialog',
        data: {
            maintenance: this.maintenance,
        }
    });
        
    dialog.afterClosed().subscribe((data) => {
        if (data?.closed || !data) {
            return;
        }

        this.pendingRequest = true;
        this.apiManager.getDetailMaintenance(this.maintenance.id).subscribe((data) => {
            this.pendingRequest = false;
            this.maintenance = data;
            this.fetchDailyQuestionary(this.maintenance.technician?.id);
            this.fetchMaintenanceTask().subscribe();
        })
    });
    
  }
}
